import { render, staticRenderFns } from "./GooglePlayIcon.vue?vue&type=template&id=34e2ea2f"
import script from "./GooglePlayIcon.vue?vue&type=script&lang=js"
export * from "./GooglePlayIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports